import { v4 as uuid } from "uuid";
import React from "react";
import DashBoard from "./views/base/DashBoard";
import LoginController from "@/controllers/authorisation/LoginController";
import { DndProvider } from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";

import CookieHelper from "helpers/cookie";
import AppController from "./controllers/AppController";
import i18NBase from "./i18n";
import moment from 'moment';
import momentNL from 'moment/locale/nl';
import { ACTION_STATUS, ACTIONS } from "./WebWorkers/constants"
import { TIMER_ACTIONS } from "./WebWorkers/constants"

window.uuid = function(){ return uuid().slice(0, 8)}

import DedicatedWorkerClass from './WebWorkers/DedicatedWorkerClass';
import TimerController from "./components/Timer/TimerController";


class App extends React.Component {
  constructor(props) {
    super(props);
    this.menuRef = React.createRef();

    var now = moment.locale('nl',momentNL );

    this.rawAuthObj = CookieHelper.getCookie("ppc_obj");
    if( typeof(this.rawAuthObj) !== 'undefined' && this.rawAuthObj != null ) {
    } else {
    }

     this.orderTableWorker = null
    this.state = {
      isWebSocketActiveInWorker: false
    }

  // At last, if the user has denied notifications, and you
  // want to be respectful there is no need to bother them anymore.
      }

  
 setWebSocketStatus (status) {
    this.setState({isWebSocketActiveInWorker: status})
  }

  closeWorker () {
    this.orderTableWorker.terminate()
    this.setWebSocketStatus(false)
  }

  createWorker () {
    this.orderTableWorker = new DedicatedWorkerClass({
      func: this.workerOnMessageHandler,
      ctx: this
    })
    this.orderTableWorker.postMessage({
      action: ACTIONS.ORDER_TABLE_INIT,
      payload: {
        url: process.env.REACT_APP_WS_ENDPOINT
      }
    })
  }



  workerOnMessageHandler (workerData) {
    switch(workerData.action) {
      case ACTIONS.WEB_SOCKET_ONOPEN:
        this.setWebSocketStatus(true)
        console.log('Web socket successfully opened')
        break
      case ACTIONS.ORDER_TABLE_DATA_RECEIVED:
        console.debug('New order table data received', workerData.data)
        break
      default: 
//        noOp()
        break
    }
  }  

    componentDidMount =() =>  {
        //this.notifyMe();
        i18NBase.init();
 this.createWorker()
    window.addEventListener('unload', () => this.closeWorker())        
    }
    
    notifyMe = () => {
  if (!("Notification" in window)) {
    // Check if the browser supports notifications
    alert("This browser does not support desktop notification");
  } else if (Notification.permission === "granted") {
    // Check whether notification permissions have already been granted;
    // if so, create a notification
    const notification = new Notification("Hi there!");
    // …
  } else if (Notification.permission !== "denied") {
    // We need to ask the user for permission
    Notification.requestPermission().then((permission) => {
      // If the user accepts, let's create a notification
      if (permission === "granted") {
        const notification = new Notification("Hi there!");
        // …
      }
    });
  }
}
      
    render() {
      return (
        <div className="App" id="mainApp">
            <TimerController timerId="timer 1"/>
            <AppController />
        </div>
      );
    }
  }

export default App;


/**
 * 
 *          <DndProvider backend={HTML5Backend}>
            {this.rawAuthObj && 
                <DashBoard />
                }
                
                {!this.rawAuthObj &&
                  <LoginController />
                }
            </DndProvider>

 * 
 */